import isNil from 'lodash-es/isNil';

import { FACETING_ATTRIBUTE_PREFIX } from '../constants';
import { QUERY_FIELD_NAME } from '../entities';
import { SearchState } from '../types';

const prefixAttributeName = (attributeName: string) =>
  attributeName.replace(FACETING_ATTRIBUTE_PREFIX, '');

// we need to manually append items to search params,
// because by default URLSearchParams produces incompatable array format
function convertToQueryString(state: SearchState): string {
  const searchParams = new URLSearchParams();
  const { menu: refinements, query, toggle: toggleRefinements } = state;

  if (query) {
    searchParams.append(QUERY_FIELD_NAME, query);
  }

  if (refinements) {
    Object.entries(refinements).forEach(([key, value]) => {
      if (isNil(value) || !value.length) {
        return;
      }
      const name = prefixAttributeName(key);
      if (Array.isArray(value)) {
        value.forEach(valueItem => searchParams.append(name, valueItem));
      } else {
        searchParams.append(name, value);
      }
    });
  }

  if (toggleRefinements) {
    Object.entries(toggleRefinements).forEach(([key, value]) => {
      const name = prefixAttributeName(key);
      const encodedValue = value === true ? '1' : '0';

      searchParams.append(name, encodedValue);
    });
  }
  return searchParams.toString();
}

export const getUrlFromSearchState = (path: string, state: SearchState): string => {
  const queryString = convertToQueryString(state);

  return queryString ? `${path}?${queryString}` : path;
};
